<!-- Main Footer-->
<div class="main-footer text-center">
    <div class="container">
        <div class="row row-sm">
            <div class="col-md-12">
                <span>Copyright © {{ today | date: 'y'}}
                    Ftn Developed by <a style="color: #f8f8f8;" href="https://app-blender.com">App
                        Blender</a>
                    All rights reserved.</span>
            </div>
        </div>
    </div>
</div>
<!--End Footer-->